import { useGetExperimentVariantForUserQuery } from "@/graphql/queries/experiments/experiments.graphql.types";
import { useUserAnalyticsId } from "./useUserAnalyticsId";

export const useGetActiveExperimentVariant = (
  code: string,
  medspaId?: string
) => {
  const userAnalyticsId = useUserAnalyticsId();
  const experimentData = useGetExperimentVariantForUserQuery({
    variables: {
      userId: userAnalyticsId,
      experimentCode: code,
      medspaId: medspaId,
    },
    skip: !code,
  });
  return experimentData.data?.experiment?.variant?.code;
};
